<template>
  <div class="menu-box" :class="[$COMPANY_NAME]">
    <template v-for="menu in calMenuList">
      <el-submenu v-if="menu.children && menu.children.length" :index="menu.path" :key="menu.ID" :disabled="menu.DiffState">
        <template slot="title">
          <i :class="menu.Icon"></i>
        </template>
        <!-- <div class="parent-title" :dataCompany="$COMPANY_NAME"> -->
        <div class="parent-title">
          {{ menu.Title }}
        </div>
        <menu-tree :menuList="menu.children" :isShowIcon="false" />
      </el-submenu>
      <el-menu-item v-else :index="menu.path" :key="menu.ID" :disabled="menu.DiffState">
        <i :class="menu.Icon" v-if="isShowIcon"></i>
        <span slot="title">{{ menu.Title }}</span>
      </el-menu-item>
    </template>
  </div>
</template>
<script>
export default {
  name: 'menuTree',
  props: {
    menuList: {
      type: Array,
      default: () => [],
    },
    isShowIcon: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    calMenuList() {
      // 处理路由路径
      let routes = this.$router.getRoutes();
      this.menuList.forEach((item) => {
        let system = this.$route.path.split('/')[1];
        let find = routes.find((val) => val.path == `/${system}/${item.Url}`);
        if (!!find) {
          item.path = find.path;
          item.DiffState = false;
        } else {
          item.path = '';
          item.DiffState = true;
        }
      });
      return this.menuList;
    },
  },
  created() {},
  data() {
    return {};
  },
};
</script>
<style scoped lang="less">
.menu-box {
  .styleChange(#154f9d); // 默认颜色
}
.menu-box.jyd {
  .styleChange(#eecd22); // 金源达颜色
}
.menu-box.kr {
  .styleChange(#e62129); // 金源达颜色
}
// .menu-box.hf {
//   .styleChange(#b83431); // 汇丰颜色
// }

.styleChange(@color) {
  .el-menu-item,
  .el-submenu {
    height: 40px;
    padding: 0;
    margin: 32px 12px;
    border-radius: 12px;
    overflow: hidden;
    /deep/ .el-tooltip,
    /deep/ .el-submenu__title {
      height: 40px;
      padding: 0 !important;
      border-radius: 12px;
      line-height: 40px;
      text-align: center;
      i {
        color: #8391b4;
        margin-right: 0;
      }
    }
    /deep/ .el-submenu__title:focus,
    /deep/ .el-submenu__title:hover {
      color: @color;
      background: #fff;
      i {
        color: @color;
      }
    }
    /deep/ .el-submenu__icon-arrow {
      display: none;
    }
  }

  :deep(.is-active) {
    background-color: @color;
  }

  .is-active {
    /deep/ .el-tooltip,
    /deep/ .el-submenu__title {
      background: @color !important;
      i {
        color: #fff !important;
      }
    }
  }
  .el-menu-item:focus,
  .el-menu-item:hover {
    color: @color;
    background: #fff;
    i {
      color: @color;
    }
  }
  .is-active:hover {
    i {
      color: #fff;
    }
  }
}
</style>
